module.exports = __webpack_public_path__ + "static/img/bg.cccd5981.jpg";